<div class="row" style="margin: 0 0 10px 0;">
    <div class="col int-tab" (click)="srvObavijesti.frmSendStep = 1" [ngStyle]="{'background-color': srvObavijesti.frmSend && srvObavijesti.frmSend.errors?.err ? '#ffe8cb' : '#d5ffef'}">
        <!-- <button type="button" class="btn mybtn-info w-100" (click)="srvObavijesti.frmSendStep = 1">Primatelji</button> -->
        <i *ngIf="srvObavijesti.frmSend && srvObavijesti.frmSend.errors?.err " class="fa fa-exclamation-triangle" style="color: #fb7575;" aria-hidden="true"></i> Primatelji
    </div>
    <div class="col int-tab" (click)="srvObavijesti.frmSendStep = 2" [ngStyle]="{'background-color': srvObavijesti.frmSend && srvObavijesti.frmSend.get('tekst').errors ? '#ffe8cb' : '#d5ffef'}">
        <!-- <button type="button" class="btn mybtn-cancel w-100" (click)="srvObavijesti.frmSendStep = 2">Tekst poruke</button> -->
        <i *ngIf="srvObavijesti.frmSend && srvObavijesti.frmSend.get('tekst').errors" class="fa fa-exclamation-triangle" style="color: #fb7575;" aria-hidden="true"></i> Tekst poruke
    </div>
</div>

<form *ngIf="srvObavijesti.frmSend" [formGroup]="srvObavijesti.frmSend" style="padding: 5px 12px;">

    <div *ngIf="srvObavijesti.frmSendStep == 1">

        <div>
            <mat-radio-group formControlName="chkID" (change)="grpChange()" aria-label="Select an option"
                class="d-flex flex-column">
                <mat-radio-button [value]="1">Svi članovi</mat-radio-button>
                <mat-radio-button [value]="2">Određena poslovna jedinica</mat-radio-button>
                <mat-radio-button *ngIf="srvObavijesti.objGrupe" [value]="3">Određena grupa</mat-radio-button>
                <!-- <mat-radio-button value="4">Pojedinačni odabir</mat-radio-button> -->
            </mat-radio-group>
        </div>


        <!--Poslovne jedinice-->
        <div *ngIf="srvObavijesti.frmSend.controls['chkID'].value == '2'" class="collapse d-flex flex-column"
            id="clpsPosJed">
            <mat-radio-group formControlName="posJedID" aria-label="Select an option" class="d-flex flex-column">
                <mat-radio-button style="margin-left: 20px;" *ngFor="let x of srvObavijesti.objPosJed"
                    [value]="x.PoslJedID">
                    {{x.NazivPos}}</mat-radio-button>
            </mat-radio-group>
        </div>

        <!--Grupe-->
        <div *ngIf="srvObavijesti.frmSend.controls['chkID'].value == '3'" class="collapse d-flex flex-column"
            id="clpsGrupe">
            <mat-radio-group formControlName="grpID" aria-label="Select an option" class="d-flex flex-column">
                <mat-radio-button style="margin-left: 20px;" *ngFor="let x of srvObavijesti.objGrupe" [value]="x.grpID">
                    {{x.grpOpis}}</mat-radio-button>
            </mat-radio-group>
        </div>

        <!--Članovi-->
        <div *ngIf="srvObavijesti.frmSend.controls['chkID'].value == '4'" class="collapse d-flex flex-column"
            id="clpsGrupe">
            <mat-radio-group formControlName="clanID" aria-label="Select an option" class="d-flex flex-column">
                <mat-radio-button style="margin-left: 20px;" *ngFor="let x of srvObavijesti.objClanovi"
                    [value]="x.clanID">
                    {{x.Ime + ' ' + x.Prezime}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <!-- <mat-error *ngIf="srvObavijesti.frmSend.errors?.err" style="text-align: center;">{{srvObavijesti.frmSend.errors.err}}</mat-error> -->
    </div>

    <div *ngIf="srvObavijesti.frmSendStep == 2">

        <mat-form-field class="w-100">
            <textarea matInput type="text" formControlName="tekst" placeholder="tekst poruke - max 750 znakova" style="height: 200px;"
                required> </textarea>
            <mat-error *ngIf="srvObavijesti.frmSend.controls['tekst'].errors?.required">Niste upisali tekst poruke
            </mat-error>
            <mat-error *ngIf="srvObavijesti.frmSend.controls['tekst'].errors?.maxlength">Duljina poruke je maksimalno 750 znakova
            </mat-error>
        </mat-form-field>

    </div>

    <div *ngIf="srvObavijesti.frmSend.errors?.err" class="alert alert-warning"
        style="padding: 5px; margin: 0; text-align: center; background-color: #ffe8cb;">
        {{srvObavijesti.frmSend.errors.err}}
    </div>

    <button *ngIf="srvObavijesti.frmSendStep == 1 && !srvObavijesti.frmSend.errors?.err" type="button"
        class="btn mybtn-info w-100" style="margin-top: 15px;" (click)="nastavi()">Nastavi</button>
    <button *ngIf="srvObavijesti.frmSendStep == 2 && srvObavijesti.frmSend.valid" type="button" class="btn mybtn-info w-100" style="margin-top: 15px;"
        (click)="posalji()">Pošalji</button>

</form>